import { createStore } from '@stencil/store';

const { state, onChange } = createStore({
  isOpen: false,
});

export {
  state,
  onChange
};
